import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb } from 'lucide-react';
export function BikeStorySection() {
  return <section className="py-12 md:py-16 bg-amber-50/50 text-navy" data-id="element-17">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-18">
        <div className="text-center mb-8" data-id="element-19">
          <h2 className="text-3xl font-bold mb-6 text-gold-600" data-id="element-20">
            La historia que lo cambia todo
          </h2>
        </div>

        <div className="bg-white border border-slate-100 rounded-3xl p-8 mb-8 text-center shadow-sm" data-id="element-21">
          <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-22">
            Cuando un niño aprende a andar en bicicleta, nadie le dice{' '}
            <span className="text-navy font-bold" data-id="element-23">
              "sos malo para las bicicletas"
            </span>{' '}
            después de que se cae. Nadie lo compara con el vecino. Se cae. Se
            levanta. Lo intenta de nuevo.
          </p>
          <p className="text-xl font-bold text-gold-600" data-id="element-24">
            La lectura funciona exactamente igual.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gold/10 text-navy rounded-2xl p-6 shadow-sm border border-gold/20 flex items-start gap-4" data-id="element-25">
          <Lightbulb className="w-8 h-8 flex-shrink-0 mt-1" data-id="element-26" />
          <div data-id="element-27">
            <p className="font-bold mb-2" data-id="element-28">
              La próxima vez que tu hijo diga "soy malo para leer", contale que
              aprender a leer bien es como aprender a andar en bicicleta.
              Después preguntale: "¿En qué intento estás hoy?"
            </p>
            
          </div>
        </motion.div>
      </div>
    </section>;
}